<div class="container-fluid header py-5">
    <div class="container">
        <div class="row">
            <div class="col">
                <h1 class="text-start mb-0 made-in-usa">Privacy Policy</h1>
                <!-- <h5 class="text-start mt-0">HOW TO FIND YOUR MEASUREMENT</h5> -->
            </div>
        </div>
    </div>
</div>

<div class="container my-5">
    <div class="row">
        <div class="col">
            <div [innerHTML]="brandData?.privacyPolicy.body"></div>
        </div>
    </div>
</div>